import { jsxs, jsx } from "react/jsx-runtime";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useState, useEffect } from "react";
const log = (message, ...args) => {};
const CardError = ({
  error
}) => {
  const [devModeEnabled, setDevModeEnabled] = useState(false);
  const [showDetailedError, setShowDetailedError] = useState(false);
  let source = null;
  const typedError = error;
  try {
    const fileStr = typedError.stack?.split("\n")[1]?.replace(/^\s+at\s+/, "") ?? "";
    if (fileStr) {
      const file = new URL(fileStr);
      const t = file.searchParams.get("t") || "";
      const [hash, line, column] = t.split(":");
      source = {
        file: file.pathname,
        line: line || "",
        column: column || "",
        hash: hash || ""
      };
    }
  } catch (e) {
    log("Error parsing error stack", e);
  }
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.shiftKey) {
        setDevModeEnabled(true);
      }
    };
    const handleKeyUp = event_0 => {
      if (!event_0.shiftKey) {
        setDevModeEnabled(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
  return /* @__PURE__ */jsxs(Box, {
    onMouseEnter: () => setShowDetailedError(true),
    onMouseLeave: () => setShowDetailedError(false),
    p: 2,
    sx: {
      backgroundColor: "#fff",
      position: "relative",
      boxShadow: "0px 4px 14px rgba(0, 0, 0, 0.05)",
      borderRadius: "12px",
      border: "1px solid rgba(0, 0, 0, 0.1)"
    },
    alignSelf: "flex-start",
    children: [/* @__PURE__ */jsxs(Box, {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      sx: {
        backgroundColor: "#f8d7da",
        border: "1px solid #f5c6cb",
        borderRadius: "8px",
        padding: 2,
        color: "#721c24",
        textAlign: "center",
        minHeight: "6rem",
        display: showDetailedError && devModeEnabled ? "flex" : "none",
        pointerEvents: "none",
        "&:hover, &.show": {
          display: "flex",
          pointerEvents: "auto"
        }
      },
      className: showDetailedError && devModeEnabled ? "show" : "",
      children: [/* @__PURE__ */jsx(ReportProblemRoundedIcon, {
        sx: {
          color: "#f44336",
          mb: 1
        }
      }), /* @__PURE__ */jsx(Typography, {
        variant: "body2",
        children: typedError.message
      }), ".", source && /* @__PURE__ */jsxs(Typography, {
        variant: "caption",
        sx: {
          mb: 3,
          wordBreak: "break-all",
          width: "100%"
        },
        children: [/* @__PURE__ */jsx("strong", {
          children: "File:"
        }), " ", source.file, /* @__PURE__ */jsx("br", {}), /* @__PURE__ */jsx("strong", {
          children: "Line:"
        }), " ", source.line, /* @__PURE__ */jsx("br", {}), /* @__PURE__ */jsx("strong", {
          children: "Column:"
        }), " ", source.column, /* @__PURE__ */jsx("br", {})]
      })]
    }), /* @__PURE__ */jsxs(Box, {
      sx: {
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: 2,
        color: "#000",
        textAlign: "center",
        minHeight: "6rem",
        display: showDetailedError && devModeEnabled ? "none" : "block",
        pointerEvents: "none",
        "&:hover, &.hide": {
          display: "none",
          pointerEvents: "auto"
        }
      },
      className: showDetailedError && devModeEnabled ? "hide" : "",
      children: [/* @__PURE__ */jsx(Typography, {
        variant: "h6",
        sx: {
          fontSize: "1rem",
          lineHeight: "1.4rem",
          fontWeight: 600
        },
        children: "Something went wrong"
      }), /* @__PURE__ */jsxs(Typography, {
        variant: "caption",
        sx: {
          mb: 3
        },
        children: ["An unexpected error occurred.", /* @__PURE__ */jsx("br", {})]
      })]
    })]
  });
};
export { CardError as default };